<template>
    <div :class="isFullWidth ? 'w-100' : ''" :style="hasMaxWidth ? maxWidthStyle : ''">
        <field-renderer v-if="component.type === 'Field' && !isForm" :field="component.value"
                        :document="document" :component="component" :containerWidth="containerWidth"
                        :table="table"></field-renderer>
        <form-element v-else-if="component.type === 'Field' && isForm" :table="table" :field="component.value"
                      :required="component.required" :component="component.component"
                      :document="document"></form-element>
        <label-renderer v-else-if="isLabel" :component="currentComponent" :containerWidth="containerWidth" :layout="layout"></label-renderer>
        <text-renderer v-else-if="isText" :component="currentComponent" :containerWidth="containerWidth"></text-renderer>
        <header-renderer v-else-if="isHeader" :component="currentComponent" :layout="layout"></header-renderer>
        <link-renderer v-else-if="component.type === 'Link'" :component="component" :layout="layout"></link-renderer>
        <button-renderer v-else-if="component.type === 'Button'" :component="component" :execute-click="true"
                         @onSaveEvent="save" @onSignUpEvent="signUp" @onSignInEvent="signIn" :layout="layout"></button-renderer>
        <view-wrapper v-else-if="component.type === 'View'" :viewId="component.value" :show-header="showHeader"></view-wrapper>

        <row-component-renderer v-else-if="component.type === 'RowContainer'" :component="component" :execute-click="true"
                                :layout="layout"></row-component-renderer>

        <div v-else>N/A - {{component.type}}</div>
    </div>
</template>

<script>
    import FieldRenderer from "./FieldRenderer.vue";
    import LabelRenderer from "./LabelRenderer.vue";
    import HeaderRenderer from "./HeaderRenderer.vue";
    import ViewRenderer from "./ViewRenderer.vue";
    import FormElement from "../form/FormElement.vue";
    import LinkRenderer from "./LinkRenderer.vue";
    import ViewWrapper from "../ViewWrapper.vue";
    import ButtonRenderer from "./ButtonRenderer.vue";
    import DataService from "../../services/DataService";
    import AuthUtil from "../../utils/AuthUtil";
    import UserService from "../../services/UserService";
    import FieldValidator from "../../utils/FieldValidator";
    import TextRenderer from "./TextRenderer.vue";
    import RowComponentRenderer from "./RowComponentRenderer.vue";

    export default {
        name: 'ComponentRenderer',
        components: {
            RowComponentRenderer,
            TextRenderer,
            ButtonRenderer,
            ViewWrapper,
            LinkRenderer,
            FormElement,
            ViewRenderer,
            HeaderRenderer,
            LabelRenderer,
            FieldRenderer
        },
        props: ['component', 'table', 'document', 'view', 'layout', 'containerWidth'],
        data () {
            return {
                model: this.$root.model,
                service: new DataService(this.table.id)
            }
        },
        computed: {
            isFullWidth() {
                return this.isChildView || (this.component.type === 'Field' && this.isForm && !this.hasMaxWidth)
            },
            hasMaxWidth() {
                return this.component.component && this.component.component.style && this.component.component.style.maxWidth
            },
            maxWidthStyle() {
                return `max-width: ${this.component.component.style.maxWidth}px;`
            },
            isForm() {
                return this.view.view_type === 'form'
            },
            isLabel() {
                return this.component.type === 'Label'
            },
            isText() {
                return this.component.type === 'Text'
            },
            isHeader() {
                return this.component.type === 'Header'
            },
            isChildView() {
                return this.component.type === 'View'
            },
            currentComponent() {
                return this.component
                // return this.hasComponentStyles ? this.fieldComponent : this.component
            },
            showHeader() {
                if(this.component.showHeader === true || this.component.showHeader === false) {
                    return this.component.showHeader
                }

                return true
            },
            hasComponentStyles() {
                return !!this.component.component && !!this.component.component.type
            },
            fieldComponent() {
                this.component.component.value =  this.fieldValue
                return this.component.component
            },
            fieldValue() {
                return this.document[this.component.value.index]
            }
        },
        methods: {
            signUp() {
                let authUtil = new AuthUtil(this.table, this.document)
                let service = new UserService()

                let site = window.location.hostname
                service.signUp(authUtil.getEmail(), authUtil.getPassword(), authUtil.getName(), site)
            },
            signIn() {
                let authUtil = new AuthUtil(this.table, this.document)
                let service = new UserService()

                let site = window.location.hostname
                service.login(authUtil.getEmail(), authUtil.getPassword(), site)
            },
            save() {
                let isFormValid = true
                // NOTE: the method below traverses the entire layout to get form fields (very inefficient)
                let formComponents = webase.utils.layout.getFormComponents(this.layout)

                for(let i = 0; i < formComponents.length; i++) {
                    let formField = formComponents[i]

                    if (formField.required) {
                        let validator = new FieldValidator(formField.value, this.document)
                        let isFieldValid = validator.isValid()

                        if(!isFieldValid) {
                            isFormValid = false
                        }
                    }
                }

                if(!isFormValid) {
                    return
                }

                if(this.view.published && this.model.currentUser === null) {
                    this.saveOnWebsite()
                    return
                }

                this.saveInApp()
            },

            saveInApp() {
                this.model.loading = true

                this.service.save(this.document).then((response) => {

                    this.model.loading = false

                    if(this.component.redirectTo) {
                        this.$router.push({name: 'view-renderer', params: {id: this.component.redirectTo}})
                    }
                    else if(this.component.resource) {
                        if(this.component.resourceType === 'View') {
                            this.$router.push({name: 'view-renderer', params: {id: this.component.resource}})
                        }
                        else {
                            this.openPageOrUrl()
                        }
                    }
                    else {
                        this.$router.go(-1)
                    }

                }).catch((message) => {
                    console.log('error saving document')
                    console.log(message)
                    this.model.loading = false
                })
            },

            saveOnWebsite() {
                this.model.loading = true

                webase.services.view.create(this.view.id, this.document).then(() => {
                    this.model.loading = false

                    if(this.component.redirectTo) {
                        this.model.currentViewId = this.component.redirectTo
                    }
                    else if(this.component.resource) {
                        if(this.component.resourceType === 'View') {
                            this.model.currentViewId = this.component.resource
                        }
                        else {
                            this.openPageOrUrl()
                        }
                    }
                    else {
                        this.model.saveSuccessMessage = 'Thank you!'
                    }

                }).catch((message) => {
                    console.log('error saving public document!')
                    console.log(message)
                    this.model.loading = false
                })
            },

            openPageOrUrl() {
                if(this.component.resourceType === 'URL') {
                    window.open(this.component.resource)
                }
                else if(this.component.resourceType === 'Page') {
                    let url = webase.utils.app.getBasePageUrl() + this.component.resource
                    window.open(url, '_self')
                }
            },

            getComponent(localComponent) {
                if(!!localComponent.component && !!localComponent.component.type) {
                    localComponent.component.value = this.fieldValue
                    return JSON.parse(JSON.stringify(localComponent.component))
                }

                return JSON.parse(JSON.stringify(localComponent))
            }
        }
    }
</script>

<style>

</style>
